module.exports = __webpack_public_path__ + "7d205ccad3734dacb3438b279f3583f9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/navigators/ic-section-miniclass.svg
// module id = 1496
// module chunks = 3